import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Button from "components/base/Button";
import { usePermissionModal } from "contexts/PermissionModalContext";

export default function ButtonAtualizar() {
    const { getQueryRetryHandler, getMutationErrorHandler } = usePermissionModal();

    const query = useQuery({
        queryKey: ["atualizacaoRegraFiscal"],
        queryFn: () => axios.get("/api/regraFiscal/atualizando"),
        refetchInterval: 10000,
        retry: getQueryRetryHandler({
            queryKey: ["atualizacaoRegraFiscal"],
            defaultMessage: "Você não possui permissão para atualizar regras fiscais."
        }),
    });

    const mutation = useMutation({
        mutationFn: () => axios.post("/api/regraFiscal/atualizar"),
        onError: getMutationErrorHandler("Você não possui permissão para atualizar regras fiscais.")
    });

    const handleRevisar = async () => {
        await mutation.mutateAsync();
        query.refetch();
    };

    return (
        <Button
            variant="outline-primary"
            loading={
                query.data?.data ||
                query.isLoading ||
                mutation.isPending
            }
            loadingPosition="start"
            onClick={handleRevisar}
        >
            Atualizar
        </Button>
    )
}